var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticStyle: { display: "none" } },
    [_vm._t("marker"), _vm._v(" "), _vm._t("popup")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }